import { Link } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import { Badge } from '../ui/Badge';
import { useAdmin } from '../AdminContext';
import { btnPrimary, btnSecondary } from '../ui/styles';
import { dayLong } from '../../core/format/dates';
import { OWNER_STAFF_ID } from '../../core/rules/salonDays';
import type { InboxBooking } from '../../core/types/adminRequests';

/** Eén afspraakaanvraag. Een ander tijdstip gaat via het dossier (klant) of per mail (gast). */
export function InboxBookingRow({
  booking: b,
  onConfirm
}: {
  booking: InboxBooking;
  onConfirm: () => void;
}) {
  const {
    index
  } = useAdmin();
  const t = index.treatmentBySlug(b.booking.treatmentSlug);
  const what = `${t?.name ?? b.booking.treatmentSlug} · ${b.booking.name}`;
  return <li className="flex flex-wrap items-center gap-x-5 gap-y-3 px-5 py-4" data-id="element-1664" data-mp="1jfx0nqhmndq">
      <span className="min-w-0 flex-1" data-id="element-1665" data-mp="3jrnhm1zddhk4">
        <span className="flex flex-wrap items-center gap-2 text-[14px] text-ink" data-id="element-1666" data-mp="3oq8i82ija393">
          {what}
          {b.change === 'verzet' && <Badge tone="accent" data-id="element-1667" data-mp="1qloj7dbtbayq">Wil verzetten</Badge>}
          {b.booking.firstVisit && <Badge tone="soft" data-id="element-1668" data-mp="1ln3i7boqkn98">Eerste bezoek</Badge>}
        </span>
        <span className="block text-[13px] text-muted" data-id="element-1669" data-mp="1lmtvbwyzmw7r">
          <span className="capitalize" data-id="element-1670" data-mp="1zn4l0woka4rc">{dayLong(b.booking.date)}</span> om {b.booking.time}
          {t ? ` · ${t.durationMinutes} min` : ''} · {b.booking.email}
        </span>
      </span>
      {b.status === 'aanvraag' ? <span className="grid w-full grid-cols-2 gap-2 sm:flex sm:w-auto" data-id="element-1671" data-mp="16z0b1yyyj5iu">
          {b.customerId ? <Link to={`/be/klanten/${b.customerId}?tab=afspraken`} className={btnSecondary} aria-label={`Ander tijdstip voorstellen: ${what}`} data-id="element-1672" data-mp="12y6s7k0dggwt">
              Ander tijdstip
            </Link> : <a href={`mailto:${b.booking.email}?subject=${encodeURIComponent('Ander tijdstip')}`} className={btnSecondary} aria-label={`Ander tijdstip mailen: ${what}`} data-id="element-1673" data-mp="1bvz8aqdx3sl9">
              Ander tijdstip
            </a>}
          <button type="button" onClick={onConfirm} className={btnPrimary} aria-label={`Bevestigen: ${what}`} data-id="element-1674" data-mp="2ja2wrp1z623b">
            Bevestigen
          </button>
        </span> : <span className="flex flex-wrap items-center gap-3" data-id="element-1675" data-mp="2t0fel9ienh5r">
          <span className="flex items-center gap-1.5 text-[13px] text-sage" data-id="element-1676" data-mp="2t31nbch182pk">
            <CheckIcon className="h-4 w-4" strokeWidth={2} aria-hidden="true" data-id="element-1677" data-mp="2xyz4fl04dd3e" />
            {b.handledBy && b.handledBy.staffId !== OWNER_STAFF_ID ? `${b.handledBy.action === 'bevestigd' ? 'Bevestigd' : 'Andere tijd voorgesteld'} door ${b.handledBy.name}` : 'Bevestigd'}
          </span>
          {/* Na bevestigen niet opnieuw hoeven zoeken: door naar de dag in de agenda. */}
          <Link to={`/be/agenda?datum=${b.booking.date}`} className={btnSecondary} aria-label={`In agenda: ${what}`} data-id="element-1678" data-mp="2e9on62kq6k36">
            In agenda
          </Link>
        </span>}
    </li>;
}